export default __webpack_public_path__ + "static/media/chevron-left.1db034cc.svg";